<div class="p-1">
  <div class="d--f jc--sb bb-1 pb-1">
    <div class="grey-color f-700 fs-22">
      {{ isEditMode ? "Edit Resource" : "Add New Resource" }}
    </div>
    <div>
      <mat-icon color="primary" class="pointer f-700" (click)="cancelForm()">close</mat-icon>
    </div>
  </div>

  <form [formGroup]="resourceFormGroup" (ngSubmit)="!isLoading && submit()">
    <div *ngIf="!isEditMode">
      <div class="grey-color mb-1 f-700 mt-2">Resource Type</div>
      <div style="margin-top: 1rem">
        <mat-radio-group
          formControlName="type"
          aria-label="Select a type"
          class="d--f ai--c"
        >
          <mat-radio-button value="hospital" color="primary" class="mr-1">
            Hospital
          </mat-radio-button>
          <mat-radio-button value="rep_company" color="primary">
            Device Company
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Company logo -->
    <div class="mt-2" *ngIf="resourceFormGroup.get('type').value === 'rep_company'">
      <app-image-selector
        [image]="logoImage"
        (uploaded)="imageUploaded($event)"
        (removed)="imageRemoved()"
      ></app-image-selector>
    </div>

    <div class="grey-color pb-1 f-700 mt-2">
      {{ resourceFormGroup.get('type').value === 'hospital' ? 'Hospital' : 'Company' }} Details
    </div>

    <div class="mt-1">
      <mat-form-field style="width: 100%" color="primary" appearance="outline">
        <mat-label>Name *</mat-label>
        <input formControlName="name" matInput type="text" />
        <mat-error *ngIf="resourceFormGroup.get('name').hasError('required')">
          Name is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Hospital-specific fields -->
    <div *ngIf="resourceFormGroup.get('type').value === 'hospital'">
      <div class="d--f jc--sb mt-1">
        <div>
          <mat-form-field color="primary" appearance="outline">
            <mat-label>City</mat-label>
            <input formControlName="city" matInput type="text" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Address</mat-label>
            <input formControlName="address" matInput type="text" />
          </mat-form-field>
        </div>
      </div>
      <div class="d--f jc--sb mt-2">
        <div>
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Postal Code</mat-label>
            <input formControlName="postalCode" matInput type="text" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Contact Number</mat-label>
            <input mask="(000) 000-0000" formControlName="contactNumber" matInput type="text" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="d--f jc--fe f--g-1 mt-2">
      <button mat-raised-button color="primary" type="submit" [style.opacity]="isLoading ? 0.5 : 1">
        {{ isEditMode ? "Save" : "Add" }}
        <mat-icon class="ml-2" *ngIf="isLoading">
          <mat-spinner color="accent" diameter="20"> </mat-spinner>
        </mat-icon>
      </button>
    </div>
  </form>
</div>
